import React, { useContext, useState } from "react";
import { StoreContext } from "../../../Store/Provider";
import Header from "../Home/Header/Header";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Sidebar from "./../Home/Sidebar/Sidebar";
import axios from "axios";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import { CircularProgress } from "@material-ui/core";
import $ from "jquery";
import Button from "@material-ui/core/Button";
import "./updatePassword.css";
import { NotificationManager } from "react-notifications";
import { HOST_URL, ProjectName } from "../../../Config";
import { getUserData, localStoragekey } from "../../Common/Utility/Utils";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "../../../Route/utils/routeConstant";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function UpdatePassword() {
  const context = useContext(StoreContext);
  const classes = useStyles();
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const [password, setPassword] = useState({
    old: "",
    new: "",
    confirm: "",
  });
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  const showPassword = (passType) => {
    if (passType === "old") {
      let x = document.getElementById("oldPassword");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
      $(".oldpassIcon").toggleClass("hide");
    } else if (passType === "new") {
      let x = document.getElementById("newPassword");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
      $(".newpassIcon").toggleClass("hide");
    } else if (passType === "conf") {
      let x = document.getElementById("confPassword");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
      $(".confpassIcon").toggleClass("hide");
    }
  };

  const validPassword = new RegExp("^(?=.*?[A-Za-z])(?=.*?[0-9]).{6,}$");

  const onSave = async () => {
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        console.log(err);
        userData = {};
      });
    if (!password.old || !password.new || !password.confirm) {
      NotificationManager.error("Please fill all fields");
    } else if (password.old === password.new) {
      NotificationManager.error("Old and New Password are same");
    } else if (password.new !== password.confirm) {
      NotificationManager.error("New and Confirm Password does not match");
    } else if (!validPassword.test(password.new)) {
      NotificationManager.error("Weak passowrd, please make strong password");
    } else {
      setLoading(true);
      const URL = `${HOST_URL}api/User/ChangePassword`;
      const header = {
        Authorization: `Bearer ${userData.access_token}`,
        username: `${userData.userName}`,
        grant_type: "password",
        password: `${userData.userSecret}`,
      };
      const body = {
        UserId: userData.userName,
        OldPassword: password.old,
        NewPassword: password.new,
        ConfirmPassword: password.confirm,
      };
      await axios
        .post(URL, body, {
          headers: header,
        })
        .then((res) => {
          if (res?.data?.Success) {
            NotificationManager.success(res?.data?.ResultMessage, "", 3000);
            handleClose();
            context.setIsUserLogin(false);
            localStorage.clear();
            window.location.reload();
            history(routeConstant.Login);
          } else {
            NotificationManager.error(res?.data?.ResultMessage, "", 3000);
          }
        })
        .catch((error) => {
          if (error.response) {
            NotificationManager.error(error.response.data.ModelState, "", 3000);
          } else if (error.request) {
          } else if (error.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
      setLoading(false);
    }
  };

  return (
    <div className="home">
      <Header />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={{
            paper: clsx(classes.drawerPaperleft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            }),
          }}
        >
          <Sidebar />
        </Drawer>
        <main className={clsx(classes.content)}>
          <div className="loginScreen">
            <div
              className="loginScreenImage"
              style={{
                backgroundImage: `url(/${ProjectName}/Assets/Images/loginBg.svg)`,
                backgroundSize: "cover",
              }}
            >
              <img
                src={`/${ProjectName}/Assets/Images/LogoTransparent.png`}
                alt="LogoTransparent"
              />
            </div>
            <div className="loginScreenForm">
              <div className="loginForm">
                <div className="loginFormHeading">
                  <span>Change Password</span>
                </div>
                <div className="loginPasswordDiv">
                  <input
                    type="password"
                    id="oldPassword"
                    value={password.old}
                    className="form-control"
                    placeholder="Old Password"
                    onChange={(e) =>
                      setPassword({ ...password, old: e.target.value })
                    }
                  />
                  <span
                    className="showpassword pointer"
                    onClick={() => showPassword("old")}
                  >
                    <VisibilityOffOutlinedIcon className="oldpassIcon" />
                    <VisibilityOutlinedIcon className="oldpassIcon hide" />
                  </span>
                </div>
                <div className="loginPasswordDiv">
                  <input
                    type="password"
                    id="newPassword"
                    value={password.new}
                    className="form-control"
                    placeholder="New Password"
                    onChange={(e) =>
                      setPassword({ ...password, new: e.target.value })
                    }
                  />
                  <span
                    className="showpassword pointer"
                    onClick={() => showPassword("new")}
                  >
                    <VisibilityOffOutlinedIcon className="newpassIcon" />
                    <VisibilityOutlinedIcon className="newpassIcon hide" />
                  </span>
                </div>
                <div className="loginPasswordDiv">
                  <input
                    type="password"
                    id="confPassword"
                    value={password.confirm}
                    className="form-control"
                    placeholder="Confirm Password"
                    onChange={(e) =>
                      setPassword({ ...password, confirm: e.target.value })
                    }
                  />
                  <span
                    className="showpassword pointer"
                    onClick={() => showPassword("conf")}
                  >
                    <VisibilityOffOutlinedIcon className="confpassIcon" />
                    <VisibilityOutlinedIcon className="confpassIcon hide" />
                  </span>
                </div>
                <div className="loginFormSubmit">
                  <Button
                    variant="contained"
                    className="form-control"
                    onClick={onSave}
                  >
                    {loading ? <CircularProgress size="2rem" /> : "Save"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerLeft: {
    width: "18%",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "18%",
    minWidth: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default UpdatePassword;
